import { render, staticRenderFns } from "./EmptyView.vue?vue&type=template&id=6459d9b6"
import script from "./EmptyView.vue?vue&type=script&lang=ts"
export * from "./EmptyView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports